import { Col } from "reactstrap";
import OpeningOfLeafletsCommonCard from "./OpeningOfLeafletsCommonCard";

const OpeningOfLeaflets = () => {
  return (
    <Col xl="3" md="6" className="proorder-xl-2 proorder-md-2">
      <OpeningOfLeafletsCommonCard />
    </Col>
  );
};

export default OpeningOfLeaflets;
